var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Component } from '@mangoweb/scripts-base';
export class Share extends Component {
    constructor() {
        super(...arguments);
        this.$linkCanonical = this.getProp('url')
            ? null
            : document.querySelector("link[rel='canonical']");
        this.getListeners = () => [['click', this.handleClick]];
    }
    handleClick(event) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            const title = this.getPropOrElse('title', document.title);
            const url = this.getPropOrElse('url', ((_a = this.$linkCanonical) === null || _a === void 0 ? void 0 : _a.href) || window.location.href);
            if (navigator.share) {
                yield navigator.share({ title, url });
            }
            else if (navigator.clipboard) {
                yield navigator.clipboard.writeText(`${title}: ${url}`);
                const note = this.getProp('fallbackClipboardNote');
                if (note) {
                    alert(note);
                }
            }
        });
    }
}
Share.componentName = 'Share';
//# sourceMappingURL=index.js.map